// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/UpCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var UpCircleOutlined = function UpCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleOutlinedSvg
  }));
};

UpCircleOutlined.displayName = 'UpCircleOutlined';
export default React.forwardRef(UpCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UpCircleOutlined.js
// module id = 1987
// module chunks = 0